import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';

import {tap} from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import {fadeInToLeft, fadeInToRight, zoomIn} from '../../../../core/animations/common-animations';
import {AuthService} from '../../../../core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  animations: [fadeInToRight, fadeInToLeft, zoomIn,
    trigger('fadeContent', [
      state('hide', style({opacity: 0, transform: 'translateX(-10px)'})),
      state('show', style({opacity: 1})),
      transition('hide <=> show', animate('.6s ease'))
    ])
  ]
})
export class SignInComponent implements OnInit {
  public passwordVisibility = false;
  public readonly loginGroup: FormGroup;
  public showForm = true;
  public hasSignedIn = false;
  public fadeContent = 'hide';

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private auth: AuthService,
              private snackBar: MatSnackBar,
              private translate: TranslateService) {

    this.loginGroup = this.formBuilder.group({
      name: ['', Validators.required],
      password: ['', Validators.required],
      remember: [true]
    });
    if (localStorage.getItem('locale') != null) {
      this.translate.setDefaultLang(localStorage.getItem('locale'));
    } else {
      this.translate.setDefaultLang('kh');
    }
  }

  private _isLoading: boolean;

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public set isLoading(value: boolean) {
    this._isLoading = value;
    if (value) {
      this.loginGroup.disable();
      this.passwordVisibility = false;
    } else {
      this.loginGroup.enable();
    }
  }

  ngOnInit() {

  }


  public togglePasswordVisibility() {
    this.passwordVisibility = !this.passwordVisibility;
  }

  login() {

    if (this.loginGroup.invalid) {
      return;
    }
    this.isLoading = true;
    this.auth.authenticate({
      userName: this.loginGroup.value.name,
      password: this.loginGroup.value.password
    }).pipe(tap(() => {
      },
      () => this.isLoading = false,
      () => this.isLoading = false))
      .subscribe(() => {
        this.fadeContent = 'hide';
        this.hasSignedIn = true;
      }, error => {
        this.showLoginErrorMessage();
      });
  }

  doneFadeContent() {
    if (this.hasSignedIn && this.router.url == '/sign-in') {
      this.router.navigate(['']);
    }
  }

  private showLoginErrorMessage() {
    this.snackBar.open('Authentication failed', null, {
      duration: 2000,
      horizontalPosition: 'center',
    });
  }


}
